/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Not_Found_Go_Home_LabelInputs */

const en_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take me home`)
};

const de_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Startseite`)
};

const pt_br2_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao início`)
};

const tr_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana sayfaya dön`)
};

const zh_cn2_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

const zh_hk2_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回主頁`)
};

const ko_kr2_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈으로 이동`)
};

const ru_ru2_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На главную`)
};

const es_419_components_not_found_go_home_label = /** @type {(inputs: Components_Not_Found_Go_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al inicio`)
};

/**
* | output |
* | --- |
* | "Take me home" |
*
* @param {Components_Not_Found_Go_Home_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_not_found_go_home_label = /** @type {((inputs?: Components_Not_Found_Go_Home_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Not_Found_Go_Home_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_not_found_go_home_label(inputs)
	if (locale === "de") return de_components_not_found_go_home_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_not_found_go_home_label(inputs)
	if (locale === "tr") return tr_components_not_found_go_home_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_not_found_go_home_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_not_found_go_home_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_not_found_go_home_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_not_found_go_home_label(inputs)
	return es_419_components_not_found_go_home_label(inputs)
});